import { axios } from '@/utils/request'

const api = {
  topicList: '/adminapi/activity/topicList',
  activityList: '/adminapi/activity/activityList',
  topicDetail: '/adminapi/activity/topicDetail',
  topicEdit: '/adminapi/activity/topicEdit',
  topicAdd: '/adminapi/activity/topicAdd',
  topicDelete: '/adminapi/activity/topicDelete',
  setRank: '/adminapi/activity/setRank',
  commentList: '/adminapi/activity/commentList',
  commentDelete: '/adminapi/activity/commentDelete',
  setCommentShow: '/adminapi/activity/setCommentShow',
}

export default api


export function getTopicList(parameter) {
  return axios({
    url: api.topicList,
    method: 'get',
    params: parameter
  })
}
export function getActivityList(parameter) {
  return axios({
    url: api.activityList,
    method: 'get',
    params: parameter
  })
}
export function getTopicDetail(parameter) {
  return axios({
    url: api.topicDetail,
    method: 'get',
    params: parameter
  })
}
export function editTopic(parameter) {
  return axios({
    url: api.topicEdit,
    method: 'post',
    data: parameter
  })
}
export function deleteTopic(parameter) {
  return axios({
    url: api.topicDelete,
    method: 'post',
    data: parameter
  })
}
export function addTopic(parameter) {
  return axios({
    url: api.topicAdd,
    method: 'post',
    data: parameter
  })
}
export function deleteComment(parameter) {
  return axios({
    url: api.commentDelete,
    method: 'post',
    data: parameter
  })
}
export function getCommentList(parameter) {
  return axios({
    url: api.commentList,
    method: 'post',
    data: parameter
  })
}
export function setRank(parameter) {
  return axios({
    url: api.setRank,
    method: 'post',
    data: parameter
  })
}
export function setCommentShow(parameter) {
  return axios({
    url: api.setCommentShow,
    method: 'post',
    data: parameter
  })
}